import useAppSelector from '../app/redux/useAppSelector';
import { UserType } from '../graphql/generated/graphql';
import authTokenUtil from './authTokenUtil';

export function useIsNonVisitorUser() {
  return useAppSelector(
    (state) =>
      !!state.session.user.id && state.session.user.type !== UserType.Visitor,
  );
}

/**
 * @deprecated Use `useIsNonVisitorUser` instead unless you need to check if there could be a valid non-visitor session.
 * In that case, call `authTokenUtil.get()` directly.
 */
function useLegacyIsLoggedIn() {
  return useIsNonVisitorUser() || !!authTokenUtil.get();
}

export default useLegacyIsLoggedIn;
